import Button from '@material-ui/core/Button'
import React from 'react'
import { connect } from 'react-redux'
import ValidityErrorDialog from '../../containers/ValidityErrorDialog'
import * as actions from '../../store/actions'

class ButtonSaveFile extends React.Component {
  state = {
    errorDialog: false,
    errors: [],
  }

  tryDownload() {
    const { fileId, onCheckValidity, checkValidity, sections } = this.props
    if (checkValidity) {
      onCheckValidity(fileId, sections).then(res => {
        if (res.length === 0) this.downloadFile()
        else this.setState({ errorDialog: true, errors: res })
      })
    } else {
      this.downloadFile()
    }
  }

  showErrors() {
    const { onSetValidityErrors, onFetchSections } = this.props
    onSetValidityErrors(this.state.errors)
    onFetchSections([{ TypSekcji: 'Walidacja' }])
  }

  downloadFile() {
    const { fileId, fileName, sections, onDownloadFile } = this.props
    onDownloadFile(fileId, fileName, sections)
  }

  handleClose() {
    this.setState({ errorDialog: false, errors: [] })
  }

  render() {
    const { variant } = this.props
    return (
      <>
        <Button
          variant={variant}
          color="primary"
          onMouseUp={() => {
            this.tryDownload()
          }}
        >
          POBIERZ PLIK XML
        </Button>
        <ValidityErrorDialog
          isError={this.state.errorDialog}
          onShowErrors={() => this.showErrors()}
          onSave={() => this.downloadFile()}
          onClose={() => this.handleClose()}
        />
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    fileId: state.sprawozdanie.header.Id,
    fileName: state.sprawozdanie.fileName,
    sections: state.sprawozdanie.sections,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onDownloadFile: (id, name, sections) => {
      return dispatch(actions.downloadFile(id, name, sections))
    },
    onCheckValidity: (id, sections) => {
      return dispatch(actions.checkValidity(id, sections, false))
    },
    onSetValidityErrors: errors => {
      return dispatch(actions.setValidityErrors(errors))
    },
    onFetchSections: sections => {
      return dispatch(actions.fetchSections(sections))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ButtonSaveFile)
